App.controller('BulkExportCtrl', BulkExportCtrl);

BulkExportCtrl.$inject = [
    'localStorageService',
    'DialogService',
    'bulkExportFactory'
];

function BulkExportCtrl(localStorageService, DialogService, bulkExportFactory) {
    var vm = this;

    vm.processing = false;
    // vm.selection = 'Responses';
    vm.selection = 'ResponsesAndQuestions';
    vm.path = null;

    vm.submit = submit;

    function submit() {
        vm.processing = true;

        DialogService.success('The bulk export request is being processed.  Please do not leave, or close, this page until the file has loaded.');

        bulkExportFactory.send(vm.selection).then(function(response) {
            vm.processing = false;

            location.href = web + 'bulk-exports/' + response.filename + '?token=' + localStorageService.get('token');
        });
    }
}